import { Outlet } from 'react-router-dom';
import propTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

// components
import AppHeader from '../../components/header';
import AppFooter from '../../components/footer';
import config from '../../config/config';
import HomeSkeleton from '../../components/skeletons/home.skeleton';

// ----------------------------------------------------------------------

const AppLayout = (props) => {
  const { appName } = config;

  const {
    pageName = "",
    isLoadHeader = true,
    isLoadFooter = true,
    isLoading = false, // full page loading can be handled here
    customLoader = null, // full page loading can be handled here
    headerClassName = "",
    bodyClassName = "",
    footerClassName = "",
    customHeader = null,
    customFooter = null,
    children = <></>
  } = props;
  return (
    <>
      <Helmet>
        <title> {pageName} | {appName} </title>
      </Helmet>
      {(isLoadHeader) && <div className={`app-header ${headerClassName}`}>
        {customHeader ? <>{customHeader}</> : <AppHeader />}
      </div>}

      <div className={`app-body ${bodyClassName}`}>
        {isLoading ? customLoader ? <> {customLoader}</> : <HomeSkeleton /> : children}
        <Outlet />
      </div>

      {(isLoadFooter) && <div className={`app-footer ${footerClassName}`}>
        {customFooter ? <>{customFooter}</> : <AppFooter />}
      </div>}


    </>
  );
}
AppLayout.propTypes = {
  pageName: propTypes.string,
  isLoadHeader: propTypes.bool,
  isLoadFooter: propTypes.bool,
  customHeader: propTypes.element,
  customFooter: propTypes.element,
  children: propTypes.any,
  headerClassName: propTypes.string,
  bodyClassName: propTypes.string,
  footerClassName: propTypes.string,
}

export default AppLayout;